(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fl-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = '1';
      const slides = [...hero.querySelectorAll('.fl-hero__slide')];
      const dots = [...hero.querySelectorAll('.fl-hero__dot')];
      if (slides.length < 2) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Number(hero.dataset.interval) || 6000;
      let i = 0;
      let timer = null;
      const eager = (s) => {
        const img = s.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      };
      const show = (n) => {
        slides[i].classList.remove('is-active');
        dots[i]?.classList.remove('is-active');
        dots[i]?.removeAttribute('aria-current');
        i = (n + slides.length) % slides.length;
        eager(slides[i]);
        eager(slides[(i + 1) % slides.length]);
        slides[i].classList.add('is-active');
        dots[i]?.classList.add('is-active');
        dots[i]?.setAttribute('aria-current', 'true');
        const bar = dots[i]?.querySelector('span');
        if (bar) {
          bar.style.animation = 'none';
          void bar.offsetWidth;
          bar.style.animation = '';
        }
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (reduced) return;
        stop();
        timer = setInterval(() => show(i + 1), interval);
        hero.classList.remove('is-paused');
      };
      eager(slides[1]);
      dots.forEach((d, n) =>
        d.addEventListener('click', () => {
          show(n);
          start();
        })
      );
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
          hero.classList.add('is-paused');
        } else start();
      });
      start();
    };
    const run = () => document.querySelectorAll('[data-fl-hero]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fl-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.fl-strip').forEach((strip) => {
      const words = [...strip.querySelectorAll('.fl-strip__word')];
      if (words.length < 2) return;
      let i = 0;
      strip.classList.add('is-ready');
      words[0].classList.add('is-on');
      setInterval(() => {
        words[i].classList.remove('is-on');
        i = (i + 1) % words.length;
        words[i].classList.add('is-on');
      }, 1800);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
